<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select class="filter-item" v-model="listQuery.querymodel.SectionId" placeholder="请选择路段" collapse-tags
        :clearable="true" @change="getList()">
        <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName" :value="item.Id"></el-option>
      </el-select>
       <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.state"
        placeholder="请选择月卡状态" @change="getList()">
        <el-option label="全部月卡状态" :value="-1"></el-option>
        <el-option label="停用" :value="0"></el-option>
        <el-option label="启用" :value="1"></el-option>
       
      </el-select>
        <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.periodstate"
        placeholder="请选择有效期" @change="getList()">
        <el-option label="全部有效期" :value="-1"></el-option>
        <el-option label="已过期" :value="0"></el-option>
        <el-option label="有效" :value="1"></el-option>
       
      </el-select>
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="车牌号/备注" style="width: 200px"
        @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe style="width: 100%"
      :height="getViewHeight()" :header-cell-style="{ background: '#F3F4F7', color: '#555' }"
      :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
      <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
        :type="col.type" :width="col.width">
      </el-table-column>
      <el-table-column label="操作" align="center" :min-width="190">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" icon="el-icon-edit" v-if="authedit" @click="edit(row)">
            编辑
          </el-button>
          <el-button v-if="authdelete" icon="el-icon-delete" size="mini" type="danger" @click="deleted(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
    <mouthcarimport v-if="importdialogshow" :dialogshow="importdialogshow" @importcomplete="importcomplete"
      @cancelimportcomplete="cancelimportcomplete"></mouthcarimport>
    <addmouthcar v-if="dialogshow" :dialogshow="dialogshow" :isedit="isedit" :editform="editform"
      :sectionlist="sectionlist" @savecomplete="savecomplete" @cancelcomplete="cancelcomplete"></addmouthcar>
  </div>
</template>
<script>
import { query, deleted } from "@/api/monthcardcar";
import { query as querysectionlist } from "@/api/section";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
import addmouthcar from "./components/addmouthcar.vue";
import mouthcarimport from "./components/mouthcarimport.vue"
export default {
  components: { Pagination, Toolbar, addmouthcar, mouthcarimport },
  directives: { waves },
  data() {
    return {
      dialogshow: false,
      isedit: false,
      buttonList: [],
      sectionlist: [],
      authedit: false,
      authdelete: false,
      editform: {},
      downloadLoading: false,
      importdialogshow: false,
      list: null,
      pageIndex: 1,
      total: 0,
      columns: [
        {
          label: "序号",
          value: "index",
          align: "center",
          type: "index",
          width: 100,
        },
        { label: "所属路段", value: "SectionName", align: "center" },
        { label: "车牌号码", value: "LicencePlate", align: "center", type: "" },
        { label: "联系人", value: "LinkMan", align: "center", type: "" },
        { label: "联系电话", value: "LinkTel", align: "center", type: "" },
        { label: "开卡人", value: "EmpName", align: "center" },
        { label: "开卡时间", value: "CreateTime", align: "center" },
        { label: "有效期止", value: "EndDateFormat", align: "center" },
        { label: "备注", value: "Remark", align: "center" }
      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
          state:-1,
          periodstate:-1
        },
      },
    };
  },
  created() {
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    this.getList();
  },
  methods: {
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    create() {
      this.isedit = false;
      this.dialogshow = true;
    },
    edit(row) {
      this.editform = row;
      this.isedit = true;
      this.dialogshow = true;
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    deleted(row) {
      this.$confirm("确定删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleted({ id: row.Id }).then((res) => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        });
      });
    },
    m_Import() {
      this.importdialogshow = true;
    },
    importcomplete(item) {
      this.importdialogshow = false;
      this.getList();
    },
    cancelimportcomplete() {
      this.importdialogshow = false;
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      query(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.dataCount;
      });
    },
    m_export() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [];
        const filterVal = [];
        this.columns.forEach((item) => {
          tHeader.push(item.label);
          filterVal.push(item.value);
        });
        const exportquery = JSON.parse(JSON.stringify(this.listQuery));
        let index = 1;
        exportquery.pageIndex = 1;
        exportquery.pageSize = 1000000;
        query(exportquery).then((res) => {
          const data = res.data.map((v) =>
            filterVal.map((j) => {
              if (j === "index") {
                return index++;
              } else {
                return v[j];
              }
            })
          );
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "月卡车辆报表",
          });
          this.downloadLoading = false;
        });
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }
      if (item.BtnCode === "edit") {
        this.authedit = true;
      }
    });
  },
};
</script>